import React from 'react';
import { LinkedAccount } from '@/types/residents/home';
import { styles } from './DesktopLinkedAccountsStyles';
import { LinkedAccountsList } from '@/components/residents/linkedAccounts/LinkedAccountsList';

interface DesktopLinkedAccountsListProps {
  isLoading: boolean;
  hasAccounts: boolean;
  accounts: LinkedAccount[];
  onRemove: (account: LinkedAccount) => void;
}

export const DesktopLinkedAccountsList: React.FC<DesktopLinkedAccountsListProps> = ({
  isLoading,
  hasAccounts,
  accounts,
  onRemove,
}) => {
  return (
    <LinkedAccountsList
      accounts={accounts}
      isLoading={isLoading}
      onRefresh={() => {}}
      onRemove={onRemove}
      contentContainerStyle={[styles.scrollContent]}
      desktopItemWrapperStyle={styles.cardWrapper}
    />
  );
};


